<script setup lang="ts">
import imgAIcon from './aIcon.svg';
import imgQIcon from './qIcon.svg';
import IconChevron from 'theme/components/atoms/icons/IconChevron.vue';

const isOpen = ref(false);
const onClick = () => (isOpen.value = !isOpen.value);
</script>
<template>
  <li :class="[$style.faqList__faqItem, $style.faqItem]">
    <div :class="[$style.faqItem__q, $style.q]" @click="onClick()">
      <img
        :class="[$style.q__qIcon, $style.qIcon]"
        :src="imgQIcon"
        alt="質問"
        loading="lazy"
      />
      <p :class="[$style.q__qText, $style.qText]">
        <slot name="q" />
      </p>
      <IconChevron
        :class="[$style.q__IconChevron, $style.IconChevron]"
        :direction="isOpen ? 'up' : 'down'"
      />
    </div>
    <div v-show="isOpen" :class="[$style.faqItem__a, $style.a]">
      <img
        :class="[$style.a__aIcon, $style.aIcon]"
        :src="imgAIcon"
        alt="回答"
        loading="lazy"
      />
      <p :class="[$style.a__aText, $style.aText]"><slot name="a" /></p>
    </div>
  </li>
</template>
<style lang="scss" module>
.faqItem {
  padding: 24px;
  border: 1px solid $color-border-low-emphasis;
  border-radius: 12px;
  box-shadow: $shadow-8;
}

.q {
  display: flex;
  align-items: center;
  gap: 24px;

  @include mobile-only {
    gap: 16px;
  }

  &__qIcon {
    flex-shrink: 0;
  }

  &__qText {
    width: 100%;
    font-size: 24px;
    font-weight: bold;
    line-height: 43.2px;

    @include mobile-only {
      font-size: 18px;
      line-height: 32.4px;
    }
  }

  &__IconChevron {
    flex-shrink: 0;
    color: $color-text-and-object-accent-primary;
  }
}

.a {
  margin-top: 24px;
  display: flex;
  align-items: start;
  gap: 24px;

  @include mobile-only {
    gap: 16px;
  }

  &__aIcon {
    flex-shrink: 0;
  }

  &__aText {
    font-size: 16px;
    font-weight: bold;
    line-height: 28.8px;
    white-space: pre-line;
  }
}
</style>
